import { validationLatitudeLongitude } from 'validation-latitude-longitude';

export const validationLat = ({ required }) => [
    'test',
    [
        'lat',
        'Invalid coordinate. Latitude must be between -90 and 90 degrees.',
        value => {
            if (
                !required &&
                (value === null || value === undefined || value === '')
            ) {
                return true;
            }
            return validationLatitudeLongitude.latitude(value);
        },
    ],
];

export const validationLong = ({ required }) => [
    'test',
    [
        'long',
        `Longitude must be between -180 and 180 degrees.`,
        value => {
            if (
                !required &&
                (value === null || value === undefined || value === '')
            ) {
                return true;
            }
            return validationLatitudeLongitude.longitude(value);
        },
    ],
];

export const validationLatLong = ({ required }) => [
    'test',
    [
        'latlong',
        `Latitude must be between -90 and 90 degrees and Longitude must be between -180 and 180 degrees.`,
        value => {
            if (
                !required &&
                (value === null || value === undefined || value === '')
            ) {
                return true;
            }
            return (
                validationLatitudeLongitude.latitude(value) &&
                validationLatitudeLongitude.longitude(value)
            );
        },
    ],
];
